<template lang="">
  <nuxt-link
    class="card py-1 py-lg-2 link-underline link-underline-opacity-0 h-100"
    :to="productRoute"
  >
    <div class="card-body d-flex flex-column justify-content-between">
      <div class="d-flex justify-content-between px-2">
        <div
          class="p-1 p-lg-2 d-flex justify-content-start justify-content-lg-center flex-column flex-lg-row align-items-center align-items-lg-start w-25"
        >
          <image-brand
            v-if="product.brands"
            :image="product.brands.image"
            :name="product.brands.name"
            :max-height="40"
            :max-sm-height="20"
          />
          <div
            class="bg-danger mt-2 percentage flex-column justify-content-center align-content-center d-flex d-lg-none"
          >
            <div class="text-white text-center fs-8">
              {{ product.discount_final_percentage }}
            </div>
          </div>
        </div>

        <div class="px-2 d-flex justify-content-center mt-lg-2 w-75 w-lg-50">
          <image-product
            :image="firstImage"
            :max-height="130"
            :max-sm-height="80"
          />
        </div>

        <div
          class="bg-black percentage flex-column justify-content-center align-content-center d-none d-lg-flex w-25"
        >
          <div class="text-white text-center">
            {{ product.discount_final_percentage }}
          </div>
        </div>
      </div>
      <h6
        class="text-secondary product-name-home mt-0 mt-lg-2 px-2 px-lg-3 line-clamp-1 m-0 p-0"
      >
        {{ product.name }}
      </h6>
      <div class="px-2 px-lg-3 d-flex justify-cotent-star">
        <div
          class="text-secondary product-price-home text-decoration-line-through"
          v-html="product.price_with_tax"
        />
        <span class="text-danger fw-semibold mx-2 product-price-home">-</span>
        <div
          class="text-danger fw-semibold product-price-home"
          v-html="product.current_price_with_tax"
        />
      </div>
      <div class="mt-0 mt-lg-3 px-2">
        <div class="text-secondary ms-lg-5 sold">
          Vendido:
          <span class="fw-bold">{{ percentageSold }}%</span>
        </div>
      </div>
      <div class="w-100 d-flex flex-row mt-0 mt-lg-2 gap-0-5 px-2">
        <div
          v-for="n in 10"
          :key="n"
          class="percentage-background bg-body-secondary"
        >
          <div
            class="bg-danger percentage-sold"
            :style="{ width: calculateWidth(n) + '%' }"
          />
        </div>
      </div>
    </div>
  </nuxt-link>
</template>

<script lang="ts">
import ImageBrand from "~/components/ui/ImageBrand.vue";
import ImageProduct from "~/components/ui/ImageProduct.vue";
import { getFinalEshopUrl } from "@/utils/general";
import { vElementHover } from "@vueuse/components";
import { getProductRouteLocation } from "@/utils/productRoute";

export default {
  directives: {
    "element-hover": vElementHover,
  },
  components: {
    ImageBrand,
    ImageProduct,
  },
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {
      imageErrors: [],
      imageBrandErrors: [],
      isHovered: false,
    };
  },
  computed: {
    percentageSold() {
      let percentSold = this.product.percentage_sold
        ? this.product.percentage_sold
        : 0;
      if (percentSold < 10) {
        percentSold = 10;
      } else if (percentSold < 30) {
        percentSold = 30;
      } else if (percentSold < 60) {
        percentSold = 60;
      }
      return percentSold;
    },
    toUrl() {
      return getFinalEshopUrl(
        this.product.links && this.product.links.self
          ? this.product.links.self
          : "/",
      );
    },
    firstImage() {
      if (
        this.product &&
        this.product.images &&
        this.product.images.length > 0
      ) {
        return this.product.images[0].image;
      }
      return "/images/imagen-no-disponible.png";
    },
    productRoute() {
      return getProductRouteLocation(this.product);
    },
  },
  methods: {
    calculateWidth(n: number) {
      const percentage = n * 10;
      const diff = this.percentageSold - percentage;
      if (diff < -10) {
        return 0;
      } else if (this.percentageSold >= percentage) {
        return 100;
      } else {
        return (10 + diff) * 10;
      }
    },
    onHover(state: boolean) {
      this.isHovered = state;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-flash-offer {
  height: 136px;

  @media (min-width: 768px) {
    height: 270px;
  }

  @media (min-width: 1400px) {
    height: 288px;
  }
}

.percentage {
  height: 24px;
  width: 24px;

  @media (min-width: 992px) {
    height: 64px;
    width: 64px;
  }
}

.percentage-background {
  width: 10%;
  height: 3px;

  @media (min-width: 992px) {
    height: 6px;
  }
}

.percentage-sold {
  height: 3px;

  @media (min-width: 992px) {
    height: 6px;
  }
}
</style>
